import AnimatedLoader from '../../../components/AnimatedLoader';
import '../../../styles/containers/Prayer/prayer.scss';
import '../../../styles/containers/Prayer/components/select-faith.scss';
import Faiths from './Faiths';
import faiths from '../../../constants/PrayerFaithsConstants';
import React from 'react'
import {useEffect, useState} from 'react'
import useMoengage from '../../../hooks/useMoengage';
import NextButton from './NextButton';
import {Routes} from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import NavigationSection from './NavigationSection';
import axios from 'axios';

function SelectFaith() {
  const [userId, setUserId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFaith, setSelectedFaith] = useState('');
  const [selectedFaithObj, setSelectedFaithObj] = useState({});
  const isWebview=window.navigator.userAgent.includes ('wv');
  const [isPayroll, setIsPayroll] = useState(false);

  const trackEvent = useMoengage()[1];
  async function fetchUserPayrollOrNotInfo(endPoint, query) {
    var config = {
        method: 'get',
        url: `${process.env.REACT_APP_API_HOST}/v2/app/${endPoint}?${query}`,
        headers: { 
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials':'true',
          'Access-Control-Allow-Methods':'GET,HEAD,OPTIONS,POST,PUT',
          'Access-Control-Allow-Headers':'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
          "Cache-Control": null,
          "X-Requested-With": null  
        },
    };
      
    return axios(config).then((response) => {
        if(response.status === 200) {
            return response.data;
        } else {
          throw new Error('Server Error');
        }
    })
}

  useEffect(() => {
      const paramString = window.location.href.split('?')[1];
      const queryString = new URLSearchParams(paramString);
      let userIdParam;
      queryString.forEach((value, key) => {
        if (key === 'userId') userIdParam = value;
      });
      if (!userIdParam) return;
      else {
          setUserId(userIdParam);
          fetchUserPayrollOrNotInfo('checkPayrolluserOrNot', `userId=${userIdParam}`)
            .then((userData) => {
                setIsPayroll(userData.isPayrollUser);
            })
            .catch(e => {
                console.log(e.toString());
            })
          setIsLoading(false);
      };
  },[])

  const handleNextButtonClick = function () {
      Navigation.push({pathname: Routes.SELECT_GOD, search:`userId=${userId}&faith=${selectedFaith}`});
      trackEvent('faith_selected', {faith: selectedFaith});
  }
  
  return isLoading ? (
      <AnimatedLoader  containerStyle={{height: '100vh'}}/>
    ) :(<div className='__main-container' style={{minHeight: '100vh'}}>
          <NavigationSection path={`${Routes.WELCOME_PRAYER}`} search={`userId=${userId}`} isWebview={isWebview}/>
          <div className='__horizontal-center select-faith-heading'>Start your day with a prayer</div>
          <Faiths selectedFaith={selectedFaith} setSelectedFaith={setSelectedFaith} setSelectedFaithObj={setSelectedFaithObj} faiths={faiths}/>
          {selectedFaith && <NextButton handleClick={handleNextButtonClick}/>}
      </div>
  )
}

export default SelectFaith